export enum YES_NO_TYPE {
  Yes = 'Yes',
  No = 'No',
}
